export const rotate = (arr: any[], count = 1) => {
  count = count > arr.length ? count % arr.length : count;
  return [...arr.slice(count, arr.length), ...arr.slice(0, count)];
};
